// Names are unique per tenant, so a free "(copy)" or "(copy N)" is picked up front.
export function buildCopyName(name: string, taken: string[]): string {
  const used = new Set(taken.map((entry) => entry.trim().toLowerCase()));
  const base = `${name.trim()} (copy)`;
  if (!used.has(base.toLowerCase())) return base;

  for (let counter = 2; counter < 100; counter += 1) {
    const candidate = `${name.trim()} (copy ${counter})`;
    if (!used.has(candidate.toLowerCase())) return candidate;
  }
  return base;
}
